import { Container, Typography, Box, Stack, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { motion } from 'framer-motion';

const features = [
    'Timely Deliveries. 3 attempts in 72 hours.',
    'Advance customer interaction portal',
    'GST will be applicable as per Law',
    '24 to 48 hrs Cash Back',
    'Online account request',
    'COD amount more than 35,000/- per shipment must be insured by Client.',
    'Real time Finance update',
    'No Fuel Surcharge',
    'No return charges.'
];

const AboutDetailsSection = () => (
    <Container maxWidth="lg" sx={{ py: 8 }}>
        <Stack spacing={6}>
            {/* Journey Section */}
            <motion.div
                initial={{ opacity: 0, y: -40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{ duration: 0.7 }}
            >
                <Box sx={{ mt: 4 }}>
                    <Typography 
                        variant="h3" 
                        component="h2" 
                        gutterBottom
                        sx={{ 
                            color: 'secondary.main',
                            fontWeight: 600,
                            mb: 3
                        }}
                    >
                        Our Journey
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                        Entering the industry being an entrepreneur as LMP – Daraz.pk (entrepreneurial program of Daraz.pk), 
                        with a branch office in District Kasur in October, 2019 and later achieving another milestone of 
                        expansion in our operations at Kharian, Lalamusa and Dinga City in July, 2020. We are now in 
                        Lahore and Islamabad in 2021 with the Updated solutions for ECOM business.
                    </Typography>
                </Box>
            </motion.div>

            {/* Mission and Team Section */}
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={4}>
                {/* Mission Section */}
                <motion.div
                    initial={{ opacity: 0, x: -60 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.6 }}
                    transition={{ duration: 0.7 }}
                    style={{ flex: 1 }}
                >
                    <Box sx={{ mb: 4 }}>
                        <Typography 
                            variant="h3" 
                            component="h2" 
                            gutterBottom
                            sx={{ 
                                color: 'secondary.main',
                                fontWeight: 600,
                                mb: 3
                            }}
                        >
                            Our Mission
                        </Typography>
                        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                            To be the ultimate choice of contact between business and customers with most advanced ECOM Fulfillment. 
                            We believe in Continuous Professional Development towards a leading role in the industry.
                        </Typography>
                    </Box>
                </motion.div>

                {/* Team Section */}
                <motion.div
                    initial={{ opacity: 0, x: 60 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.6 }}
                    transition={{ duration: 0.7 }}
                    style={{ flex: 1 }}
                >
                    <Box sx={{ mb: 4 }}>
                        <Typography 
                            variant="h3" 
                            component="h2" 
                            gutterBottom
                            sx={{ 
                                color: 'secondary.main',
                                fontWeight: 600,
                                mb: 3
                            }}
                        >
                            Our Team
                        </Typography>
                        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                            Young professionals of the industry, ready to serve the company's vision. Our team is dedicated to 
                            providing the best service and maintaining the highest standards of professionalism.
                        </Typography>
                    </Box>
                </motion.div>
            </Stack>

            {/* Features Section */}
            <Box sx={{ mt: 4 }}>
                <Typography 
                    variant="h3" 
                    component="h2" 
                    gutterBottom
                    sx={{ 
                        color: 'secondary.main',
                        fontWeight: 600,
                        mb: 3
                    }}
                >
                    Salient Features of Our COD Services
                </Typography>
                <Stack>
                    {features.map((feature, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, x: 60 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true, amount: 0.6 }}
                            transition={{ duration: 0.5, delay: idx * 0.08 }}
                        >
                            <Paper
                                elevation={3}
                                sx={{
                                    bgcolor: 'background.default',
                                    p: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                }}
                            >
                                <CheckCircleIcon sx={{ color: 'secondary.main', fontSize: 28 }} />
                                <Typography variant="body1" sx={{ fontSize: '1.08rem' }}>
                                    {feature}
                                </Typography>
                            </Paper>
                        </motion.div>
                    ))}
                </Stack>
            </Box>
        </Stack>
    </Container>
);

export default AboutDetailsSection; 